import React from 'react'
import { slugs } from '@/constants/slugs'
import { ProjectDetails } from '@/services/ProjectsService'
import { ReactFCC } from '@/types/react'

interface BlogPostContextProps extends ProjectDetails {
  children: React.ReactNode
}

const BlogPostContext = React.createContext<ProjectDetails>({
  name: 'Angel',
  pifEnabled: false,
  projectType: 'movie',
  slug: slugs.angelStudios,
})

export const BlogPostContextProvider: ReactFCC<BlogPostContextProps> = ({
  children,
  name,
  pifEnabled,
  projectType,
  slug,
}) => {
  const value = {
    name,
    pifEnabled,
    projectType,
    slug,
  }

  return <BlogPostContext.Provider value={value}>{children}</BlogPostContext.Provider>
}

export function useBlogPostContext() {
  return React.useContext(BlogPostContext)
}
